export default "__VITE_ASSET__C_byT_G1__"